import { render, staticRenderFns } from "./campaing.vue?vue&type=template&id=cf36ace8&scoped=true&"
import script from "./campaing.vue?vue&type=script&lang=js&"
export * from "./campaing.vue?vue&type=script&lang=js&"
import style0 from "./campaing.vue?vue&type=style&index=0&id=cf36ace8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf36ace8",
  null
  
)

export default component.exports